export default [
  {
    routeName: 'user_module_qseReports_quality',
    title: 'Quality',
    type: 'quality',
    icon: 'star',
    color: '#DC3545',
  },
  {
    routeName: 'user_module_qseReports_safety',
    title: 'Health and Safety',
    type: 'safety',
    icon: 'shield',
    color: '#007bff',
  },
  {
    routeName: 'user_module_qseReports_environment',
    title: 'Environment',
    type: 'environment',
    icon: 'leaf',
    color: '#28A745',
  },
];
